export default "__VITE_ASSET__735faee1__"